import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './WhatsAppButton.css';

const PHONE = '528448690089'; // Carlota's WhatsApp

const WhatsAppButton = () => {
  const { lang } = useLanguage();

  // Don't show inside the admin panel
  useEffect(() => {}, []);
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) return null;
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/login')) return null;

  const message = encodeURIComponent(
    lang === 'es'
      ? 'Hola Carlota, me interesa una obra de tu sitio.'
      : 'Hi Carlota, I am interested in a piece from your website.'
  );
  const href = `https://wa.me/${PHONE}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-fab"
      data-testid="wa-fab"
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M16 .39C7.16.39 0 7.55 0 16.39c0 2.88.78 5.7 2.27 8.16L0 32l7.65-2.21A15.92 15.92 0 0 0 16 32.39c8.84 0 16-7.16 16-16S24.84.39 16 .39Zm0 29.21c-2.6 0-5.16-.7-7.4-2.02l-.53-.31-4.55 1.31 1.34-4.42-.34-.55A13.16 13.16 0 0 1 2.83 16.4C2.83 9.12 8.72 3.23 16 3.23c7.28 0 13.17 5.89 13.17 13.17S23.28 29.6 16 29.6Zm7.55-9.86c-.41-.21-2.45-1.21-2.83-1.35-.38-.14-.65-.21-.93.21-.27.41-1.07 1.35-1.31 1.62-.24.27-.48.31-.89.1-.41-.21-1.74-.64-3.32-2.05-1.22-1.09-2.05-2.43-2.29-2.84-.24-.41-.03-.63.18-.84.19-.19.41-.48.62-.72.21-.24.27-.41.41-.69.14-.27.07-.51-.03-.72-.1-.21-.93-2.24-1.27-3.07-.34-.81-.68-.7-.93-.71l-.79-.01a1.54 1.54 0 0 0-1.12.52c-.38.41-1.47 1.44-1.47 3.5 0 2.06 1.5 4.06 1.71 4.34.21.27 2.95 4.5 7.14 6.31 1 .43 1.78.69 2.39.88.99.31 1.9.26 2.62.16.8-.12 2.45-1 2.8-1.97.34-.97.34-1.81.24-1.97-.1-.16-.37-.27-.79-.48Z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
